import userMapper from "./user";

export default state => {
  const user = userMapper(state);
  return {
    ...user,
    is_tutorial: user.tutorial_status !== 0
  };
};



// WEBPACK FOOTER //
// ./src/store/mappers/timezone.js